import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading',
		defaultMessage: 'Jira admin settings',
		description: 'Heading for the global jira settings pages',
	},
});
